import React, { useRef } from "react";
import { motion } from "framer-motion";
import {
  FaHeart,
  FaMapMarkerAlt,
  FaBed,
  FaBath,
  FaRulerCombined,
  FaChevronLeft,
  FaChevronRight,
} from "react-icons/fa";

const FeaturedProperties = () => {
  const scrollRef = useRef(null);

  const properties = [
    {
      image: "/assets/mumbai.webp",
      title: "2 BHK Luxury Apartment",
      location: "Mumbai, Maharashtra",
      price: 75,
      area: "1100 sqft",
      beds: 2,
      baths: 2,
      tag: "Hot",
      type: "Apartment",
    },
    {
      image: "/assets/banglore.webp",
      title: "Modern Villa",
      location: "Bangalore, Karnataka",
      price: 120,
      area: "2200 sqft",
      beds: 3,
      baths: 3,
      tag: "Luxury",
      type: "Villa",
    },
    {
      image: "/assets/delhi.webp",
      title: "Commercial Office Space",
      location: "Delhi NCR",
      price: 95,
      area: "1500 sqft",
      beds: 0,
      baths: 1,
      tag: "New",
      type: "Commercial",
    },
    {
      image: "/assets/kolkata.jpg",
      title: "Affordable 1 BHK Flat",
      location: "Kolkata, West Bengal",
      price: 35,
      area: "700 sqft",
      beds: 1,
      baths: 1,
      tag: "Budget",
      type: "Flat",
    },
    {
      image: "/assets/gurugoan.jpg",
      title: "Luxury Penthouse",
      location: "Gurgaon, Haryana",
      price: 150,
      area: "2500 sqft",
      beds: 4,
      baths: 3,
      tag: "Luxury",
      type: "Penthouse",
    },
    {
      image: "/assets/delhi.webp",
      title: "Luxury Penthouse",
      location: "Dwarka delhi",
      price: 150,
      area: "2500 sqft",
      beds: 4,
      baths: 3,
      tag: "Luxury",
      type: "Penthouse",
    },
  ];

  const adIndexes = [1, 3]; // Replace 2nd and 4th with ads

  const scroll = (direction) => {
    const container = scrollRef.current;
    if (container) {
      const scrollAmount = direction === "left" ? -300 : 300;
      container.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <section className="py-5" style={{ backgroundColor: "#f8f9fa" }}>
      <div className="container">
        <motion.h2
          className="text-center fw-bold text-primary mb-2"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          Featured Properties
        </motion.h2>
        <motion.p
          className="text-center text-muted mb-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.6 }}
        >
          Recommended For You
        </motion.p>

        {/* Arrows */}
        <div className="d-flex justify-content-between align-items-center mb-3">
          <button className="btn btn-light shadow" onClick={() => scroll("left")}>
            <FaChevronLeft />
          </button>
          <button className="btn btn-light shadow" onClick={() => scroll("right")}>
            <FaChevronRight />
          </button>
        </div>

        {/* Scrollable Cards */}
        <div
          ref={scrollRef}
          className="d-flex overflow-auto gap-4 pb-3"
          style={{ scrollSnapType: "x mandatory", scrollBehavior: "smooth" }}
        >
          {properties.map((property, index) => {
            if (adIndexes.includes(index)) {
              return (
                <motion.div
                  key={`ad-${index}`}
                  className="card border-0 shadow-sm rounded-4 d-flex justify-content-center align-items-center text-center bg-light text-muted"
                  style={{
                    minWidth: "280px",
                    height: "360px",
                    scrollSnapAlign: "start",
                    flexShrink: 0,
                  }}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: index * 0.2 }}
                  viewport={{ once: true }}
                >
                  <div>
                    <h5 className="fw-bold">Space for Advertisement</h5>
                    <p className="small">Your Ad could be here!</p>
                  </div>
                </motion.div>
              );
            }

            return (
              <motion.div
                key={index}
                className="card border-0 shadow-sm rounded-4"
                style={{
                  minWidth: "280px",
                  scrollSnapAlign: "start",
                  flexShrink: 0,
                }}
                whileHover={{ scale: 1.03 }}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: index * 0.2 }}
                viewport={{ once: true }}
              >
                <div className="position-relative">
                  <img
                    src={property.image}
                    alt={property.title}
                    className="card-img-top rounded-top-4"
                    style={{ height: "200px", objectFit: "cover" }}
                  />
                  <span className="badge bg-primary position-absolute top-0 start-0 m-2">
                    {property.tag}
                  </span>
                  <button className="btn position-absolute top-0 end-0 m-2 text-danger">
                    <FaHeart />
                  </button>
                </div>
                <div className="card-body">
                  <h6 className="fw-bold mb-1">{property.title}</h6>
                  <p className="text-muted small mb-2">
                    <FaMapMarkerAlt className="me-1" /> {property.location}
                  </p>
                  <div className="d-flex justify-content-between text-muted small mb-2">
                    <span><FaBed className="me-1" /> {property.beds} Beds</span>
                    <span><FaBath className="me-1" /> {property.baths} Baths</span>
                    <span><FaRulerCombined className="me-1" /> {property.area}</span>
                  </div>
                  <div className="d-flex justify-content-between align-items-center">
                    <span className="fw-bold text-primary">₹ {property.price} Lakh</span>
                    <a href="/properties" className="btn btn-sm btn-outline-primary rounded-pill">
                      View Details
                    </a>
                  </div>
                </div>
              </motion.div>
            );
          })}
        </div>

        <div className="text-center mt-4">
          <a href="/properties" className="btn btn-primary px-4 py-2 rounded-pill">
            View All Properties <i className="bi bi-arrow-right ms-2"></i>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FeaturedProperties;
